import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Monthly from "./components/Monthly";
import ThankYou from "./components/ThankYou";
import PaymentStatus from "./components/PaymentStatus";
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/monthly" element={<Monthly />} />
        <Route path="/ThankYou" element={<ThankYou />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();